import { useSelector } from "react-redux";
import axiosInstance from "config/AxiosConfig";
import { BaseResponse } from "domain/payload/response/BaseResponseDto";
import { StoreListResp } from "domain/payload/response/store/StoreListResp";
import { StoreDetailResp } from "domain/payload/response/store/StoreDetailResp";
import { PosmListResp } from "domain/payload/response/store/PosmListResp";
import { StoreUpdateReq } from "domain/payload/request/store/StoreUpdateReq";

const StoreManageService = () => {
  const { token } = useSelector((state: any) => state.auth);

  const storeList = async (): Promise<BaseResponse<StoreListResp[]>> => {
    try {
      const response = await axiosInstance.get(`/v1/legacy/merchant-store/list`, {
        headers: {
          ...axiosInstance.defaults.headers.head,
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error: any) {
      throw error.response?.data?.message || error.message;
    }
  };

  const storeDetail = async (
    id: string
  ): Promise<BaseResponse<StoreDetailResp>> => {
    try {
      const response = await axiosInstance.get(`/v1/legacy/merchant-store/detail`, {
        headers: {
          ...axiosInstance.defaults.headers.head,
          Authorization: `Bearer ${token}`,
        },
        params: { id },
      });
      return response.data;
    } catch (error: any) {
      throw error.response?.data?.message || error.message;
    }
  };

  const storeUpdate = async (
    payload: StoreUpdateReq
  ): Promise<BaseResponse<StoreDetailResp>> => {
    try {
      const response = await axiosInstance.put(
        `/v1/legacy/merchant-store/update`,
        payload,
        {
          headers: {
            ...axiosInstance.defaults.headers.head,
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error: any) {
      throw error.response?.data?.message || error.message;
    }
  };

  const posmList = async (): Promise<BaseResponse<PosmListResp[]>> => {
    try {
      const response = await axiosInstance.get(`/v1/public/posm/list`, {
        headers: {
          ...axiosInstance.defaults.headers.head,
        },
      });
      return response.data;
    } catch (error: any) {
      throw error.response?.data?.message || error.message;
    }
  };

  return {
    storeList,
    storeDetail,
    storeUpdate,
    posmList,
  };
};

export default StoreManageService;